export const formatDate = (d, options = {}) => {
    if (!d) {
        return 'N/A';
    }
    if (d) {
        d = new Date(d);
    }
    const opts = Object.assign({ withDate: true, withTime: false }, options);
    return new Intl.DateTimeFormat('fr-FR', Object.assign(Object.assign({}, opts.withDate ? { year: 'numeric', month: 'numeric', day: 'numeric' } : {}), opts.withTime ? { hour: 'numeric', minute: 'numeric' } : {})).format(d);
};
export const pluralize = (s, nb) => `${s}${nb > 1 ? 's' : ''}`;
export const getFieldFormData = (check, defaultIsValid = false) => ({
    hasBeenTouched: false,
    check,
    isValid: defaultIsValid,
    get isError() {
        return this.hasBeenTouched && !this.isValid;
    }
});
export const DaysOfWeek = [
    ['Dimanche', 'Dim'],
    ['Lundi', 'Lun'],
    ['Mardi', 'Mar'],
    ['Mercredi', 'Mer'],
    ['Jeudi', 'Jeu'],
    ['Vendredi', 'Ven'],
    ['Samedi', 'Sam']
];
export let MonthsOfYear = [
    ['Janvier', 'Jan'],
    ['Février', 'Fev'],
    ['Mars', 'Mar'],
    ['Avril', 'Avr'],
    ['Mai', 'Mai'],
    ['Juin', 'Jun'],
    ['Juillet', 'Jul'],
    ['Août', 'Aou'],
    ['Septembre', 'Sep'],
    ['Octobre', 'Oct'],
    ['Novembre', 'Nov'],
    ['Décembre', 'Dec']
];
export const QuickSessions = [{
        name: 'Ludothèque Mercredi',
        description: 'Toutes les semaines, à la ludo',
        nbPlaces: 15,
        day: 2,
        hour: 14,
        minutes: 30
    }, {
        name: 'Miniludes',
        description: 'Toutes les semaines, à la ludo',
        nbPlaces: 10,
        day: 4,
        hour: 10,
        minutes: 0
    }, {
        name: 'Ludothèque Samedi',
        description: 'Toutes les semaines, à la ludo',
        nbPlaces: 15,
        day: 5,
        hour: 10,
        minutes: 0
    }];
